import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=690f274d&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"
import style0 from "./LoaderComponent.vue?vue&type=style&index=0&id=690f274d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../Users/florent.sirigu/AppData/Roaming/nvm/v20.13.1/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f274d",
  null
  
)

export default component.exports